import { useEffect, useState } from 'react';
import {
    Grid,
    Button,
    Box,
    Divider
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
    getBatchBulkDensity,
    getBatchVolumes,
    getBiocharMass
} from '../../../../actions/conservation-burns/conservation-burn-actions';
import CbBatchVolumes from './data-tables/CbBatchVolumes';
import CbBatchBulkDensity from './data-tables/CbBatchBulkDensity';
import CbBiocharMass from './data-tables/CbBiocharMass';
import CbCorgAndHcSamples from './data-tables/CbCorgAndHcSamples';
import CbFuel from './data-tables/CbFuel';
import CbEquipmentTransport from './data-tables/CbEquipmentTransport';

export default function CbDataTables() {
    const batchData = useSelector(state => state.conservationBurnsReducer.batchVolumes.batchVolumes);
    const bulkDensity = useSelector(state => state.conservationBurnsReducer.bulkDensity.bulkDensities);
    const biocharMass = useSelector(state => state.conservationBurnsReducer.biocharMass.biocharMass);
    // const sampleData = useSelector((state) => (state.conservationBurnsReducer.sampleData.data))
    const sampleData = []
    const fuelData = useSelector((state) => (state.conservationBurnsReducer?.ignitionFuel?.data))
    // const equipmentData = useSelector((state) => (state.conservationBurnsReducer.equipmentTransport.data))
    const equipmentData = []
    const loading = useSelector(state => state.conservationBurnsReducer.loading);
    const dispatch = useDispatch();
    const [selectedCategory, setSelectedCategory] = useState('Batch Volumes');
    const { selectedProject } = useSelector(state => state.postFormData);
    let { id } = selectedProject || {}
    const projectKey = id;

    const CB_DATA_TABLES_CATEGORIES = [
        'Batch Volumes',
        'Bulk Density',
        'Biochar Mass',
        'C_ORG & H:C Samples',
        'Fuel',
        'Equipment Transport'
    ];

    useEffect(() => {
        if (selectedCategory === 'Batch Volumes') {
            dispatch(getBatchVolumes(projectKey));
        }
        else if (selectedCategory === 'Bulk Density') {
            dispatch(getBatchBulkDensity(projectKey));
        }
        else if (selectedCategory === 'Biochar Mass') {
            dispatch(getBiocharMass(projectKey));
        }
        else if (selectedCategory === 'C_ORG & H:C Samples') {
            return
        }
        else if (selectedCategory === 'Fuel') {
            return
        }
        else if (selectedCategory === 'Equipment Transport') {
            return
        }
    }, [dispatch, selectedCategory, projectKey]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Grid item xs={12} sx={{ display: 'flex', gap: 2 }}>
                {CB_DATA_TABLES_CATEGORIES.map((category) => (
                    <Button
                        key={category}
                        onClick={() => setSelectedCategory(category)}
                        variant={selectedCategory === category ? 'contained' : 'outlined'}
                    >
                        {category}
                    </Button>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Box sx={{ display: 'flex', flexDirection: 'column', px: 2 }}>
                {selectedCategory === 'Batch Volumes' &&
                    <CbBatchVolumes batchData={batchData} />
                }
                {selectedCategory === 'Bulk Density' &&
                    <CbBatchBulkDensity bulkDensity={bulkDensity} />
                }
                {selectedCategory === 'Biochar Mass' &&
                    <CbBiocharMass loading={loading} biocharMass={biocharMass} />
                }
                {selectedCategory === 'C_ORG & H:C Samples' &&
                    <CbCorgAndHcSamples sampleData={sampleData} />
                }
                {selectedCategory === 'Fuel' &&
                    <CbFuel
                        fuelData={fuelData}
                        projectId={projectKey}
                    />
                }
                {selectedCategory === 'Equipment Transport' &&
                    <CbEquipmentTransport equipmentData={equipmentData} />
                }
            </Box>
        </Box>
    )
}